import { purePost } from '../api/index.js'
/**
 * 公共埋点方法
 * @param {Array} eventParams 事件参数，格式：[{eventId: 0, param: "string", triggerTime: "string"}]
 */
export const trackEvent = (eventParams) => {
  // 组装埋点数据
  const trackData = {
    eventParams,
    userInfo: getUserInfo(),
    base: getBaseInfo()
  }
  
  // 发送埋点请求
  purePost('TRACK_EVENT_COLLECT', trackData)
}

/**
 * 获取用户信息
 */
const getUserInfo = () => {
  // 从localStorage获取用户数据
  let userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData')) : null
  userData = userData && userData.data ? JSON.parse(userData.data) : userData
  const isLogin = userData ? 1 : 0
  // 获取appSrcId（渠道ID）
  const appSrcId = localStorage.getItem('appSrc') || ''
  
  // 获取设备ID
  const deviceId = getDeviceId()
  
  // 判断是否为首日访问
  const isFirstDayVisit = checkIsFirstDayVisit()
  
  return {
    userId: userData && userData.userId ? userData.userId : '',
    isLogin,
    appSrcId,
    deviceId,
    isFirstDayVisit
  }
}

/**
 * 获取设备ID，如果不存在则生成一个并存储
 */
const getDeviceId = () => {
  let deviceId = localStorage.getItem('deviceId')
  if (!deviceId) {
    // 生成一个唯一的设备ID
    deviceId = 'device_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
    localStorage.setItem('deviceId', deviceId)
  }
  return deviceId
}

/**
 * 检查是否为首日访问
 */
const checkIsFirstDayVisit = () => {
  const firstVisitDate = localStorage.getItem('firstVisitDate')
  const today = new Date().toDateString()
  
  if (!firstVisitDate) {
    // 首次访问，存储日期
    localStorage.setItem('firstVisitDate', today)
    return 1
  } else if (firstVisitDate === today) {
    // 当天已访问过
    return 0
  } else {
    // 不是当天首次访问，但可能是新的一天
    localStorage.setItem('firstVisitDate', today)
    return 0
  }
}

/**
 * 获取基础事件参数
 */
const getBaseInfo = () => {
  // 获取浏览器信息
  const browserInfo = getBrowserInfo()
  
  // 获取操作系统信息
  const osInfo = getOsInfo()
  
  // 获取页面信息
  const pageInfo = getPageInfo()
  
  // 获取屏幕信息
  const screenInfo = getScreenInfo()
  
  // 获取时区信息
  const timezoneInfo = getTimezoneInfo()
  
  return {
    // 页面信息
    pageDomain: pageInfo.pageDomain,
    pagePath: pageInfo.pagePath,
    fullUrl: pageInfo.fullUrl,
    referrerUrl: pageInfo.referrerUrl,
    referrerPath: pageInfo.referrerPath,
    referrerDomain: pageInfo.referrerDomain,
    
    // 设备信息
    osVersion: osInfo.osVersion,
    osName: osInfo.osName,
    deviceName: osInfo.deviceName,
    
    // 时区信息
    timezone: timezoneInfo.timezone,
    tzOffset: timezoneInfo.tzOffset,
    
    // 平台信息
    platform: navigator.platform,
    
    // 语言信息
    language: navigator.language,
    
    // 页面尺寸
    pageHeight: pageInfo.pageHeight,
    pageWidth: pageInfo.pageWidth,
    
    // 浏览器信息
    browserName: browserInfo.browserName,
    browserVersion: browserInfo.browserVersion,
    
    // 屏幕信息
    screenResolution: screenInfo.screenResolution
  }
}

/**
 * 获取浏览器信息
 */
const getBrowserInfo = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  let browserName = 'unknown'
  let browserVersion = ''
  
  // 检测浏览器类型
  if (userAgent.includes('chrome')) {
    browserName = 'Chrome'
    browserVersion = userAgent.match(/chrome\/([\d.]+)/)[1]
  } else if (userAgent.includes('firefox')) {
    browserName = 'Firefox'
    browserVersion = userAgent.match(/firefox\/([\d.]+)/)[1]
  } else if (userAgent.includes('safari')) {
    browserName = 'Safari'
    browserVersion = userAgent.match(/version\/([\d.]+)/)[1]
  } else if (userAgent.includes('edge')) {
    browserName = 'Edge'
    browserVersion = userAgent.match(/edge\/([\d.]+)/)[1]
  } else if (userAgent.includes('opera') || userAgent.includes('opr')) {
    browserName = 'Opera'
    browserVersion = userAgent.match(/(opera|opr)\/([\d.]+)/)[2]
  } else if (userAgent.includes('msie') || userAgent.includes('trident')) {
    browserName = 'Internet Explorer'
    browserVersion = userAgent.match(/(msie |rv:)([\d.]+)/)[2]
  }
  
  return {
    browserName,
    browserVersion
  }
}

/**
 * 获取操作系统信息
 */
const getOsInfo = () => {
  const userAgent = navigator.userAgent.toLowerCase()
  let osName = 'unknown'
  let osVersion = ''
  let deviceName = 'unknown'
  
  // 检测操作系统
  if (userAgent.includes('windows')) {
    osName = 'Windows'
    if (userAgent.includes('windows nt 10.0')) {
      osVersion = '10'
    } else if (userAgent.includes('windows nt 6.3')) {
      osVersion = '8.1'
    } else if (userAgent.includes('windows nt 6.2')) {
      osVersion = '8'
    } else if (userAgent.includes('windows nt 6.1')) {
      osVersion = '7'
    } else if (userAgent.includes('windows nt 6.0')) {
      osVersion = 'Vista'
    } else if (userAgent.includes('windows nt 5.1')) {
      osVersion = 'XP'
    }
  } else if (userAgent.includes('mac')) {
    osName = 'macOS'
    osVersion = userAgent.match(/mac os x ([\d_]+)/)[1].replace(/_/g, '.')
  } else if (userAgent.includes('linux')) {
    osName = 'Linux'
  } else if (userAgent.includes('android')) {
    osName = 'Android'
    osVersion = userAgent.match(/android ([\d.]+)/)[1]
  } else if (userAgent.includes('ios')) {
    osName = 'iOS'
    osVersion = userAgent.match(/os ([\d_]+)/)[1].replace(/_/g, '.')
  }
  
  // 检测设备类型
  if (userAgent.includes('mobile')) {
    deviceName = 'Mobile'
  } else if (userAgent.includes('tablet')) {
    deviceName = 'Tablet'
  } else if (userAgent.includes('ipad')) {
    deviceName = 'iPad'
  } else if (userAgent.includes('iphone')) {
    deviceName = 'iPhone'
  } else {
    deviceName = 'Desktop'
  }
  
  return {
    osName,
    osVersion,
    deviceName
  }
}

/**
 * 获取页面信息
 */
const getPageInfo = () => {
  const url = new URL(window.location.href)
  const referrerUrl = document.referrer || ''
  let referrerPath = ''
  let referrerDomain = ''
  
  if (referrerUrl) {
    try {
      const referrer = new URL(referrerUrl)
      referrerPath = referrer.pathname
      referrerDomain = referrer.hostname
    } catch (error) {
      // 解析referrer失败，使用空值
    }
  }
  
  return {
    pageDomain: url.hostname,
    pagePath: url.pathname,
    fullUrl: url.href,
    referrerUrl,
    referrerPath,
    referrerDomain,
    pageHeight: Math.max(document.documentElement.scrollHeight, document.body.scrollHeight),
    pageWidth: document.documentElement.clientWidth
  }
}

/**
 * 获取屏幕信息
 */
const getScreenInfo = () => {
  return {
    screenResolution: `${screen.width}x${screen.height}`
  }
}

/**
 * 获取时区信息
 */
const getTimezoneInfo = () => {
  const date = new Date()
  const timezoneOffset = date.getTimezoneOffset()
  
  // 计算时区
  const timezone = Math.abs(timezoneOffset / 60)
  const timezoneSign = timezoneOffset < 0 ? '+' : '-'
  const timezoneString = `GMT${timezoneSign}${timezone.toString().padStart(2, '0')}:00`
  
  return {
    timezone: parseInt(timezoneString.replace(/[^\d]/g, '')),
    tzOffset: timezoneOffset
  }
}

// 将埋点方法挂载到全局
if (typeof window !== 'undefined') {
  window.trackEvent = trackEvent
}



// WEBPACK FOOTER //
// ./src/assets/utils/track.js